exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-dropdown-menu .el-dropdown-menu__item.active_menu,.el-dropdown-menu .el-dropdown-menu__item:focus,.el-dropdown-menu .el-dropdown-menu__item:not(.is-disabled):hover{background-color:#2993ff;color:#ffffff}\n", ""]);

// exports
